document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var closeBtn = document.querySelector('[data-nav-close]');
  var drawer = document.querySelector('[data-nav-drawer]');

  function openNav() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
  }

  function closeNav() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
  }

  if (toggle) toggle.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  document.querySelectorAll('[data-expandable]').forEach(function (wrap) {
    var expandToggle = wrap.querySelector('[data-expandable-toggle]');
    var content = wrap.querySelector('[data-expandable-content]');
    var label = wrap.querySelector('[data-expandable-label]');
    if (!expandToggle || !content) return;

    var moreLabel = expandToggle.dataset.labelMore || 'View More';
    var lessLabel = expandToggle.dataset.labelLess || 'View Less';

    expandToggle.addEventListener('click', function () {
      var isHidden = content.hasAttribute('hidden');
      if (isHidden) {
        content.removeAttribute('hidden');
        if (label) label.textContent = lessLabel;
      } else {
        content.setAttribute('hidden', '');
        if (label) label.textContent = moreLabel;
      }
    });
  });
});
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('#DimensionChartTrigger');
  var close = event.target.closest('#DimensionChartClose');
  var overlay = event.target.closest('#DimensionChartOverlay');

  var modal = document.getElementById('DimensionChartModal');

  if (!modal) return;

  if (trigger) {
    event.preventDefault();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('hidden');
    return;
  }

  if (close || overlay) {
    event.preventDefault();

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var modal = document.getElementById('DimensionChartModal');

  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  modal.setAttribute('hidden', '');
});
